import { globalTypes } from '../types';

import types from './types';

export const initialState = () => ({});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case globalTypes.INITIALIZE:
            return initialState();
        case types.SET_SOCIAL_INFORMATION:
            return { ...state, ...action.payload };
        case types.INITIALIZE:
            return initialState();
        default:
            return state;
    }
};

export default reducers;
